<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Devices
          </div>
          <div class="card-block">
            <table class="table table-bordered table-striped table-condensed">
              <thead>
                <tr>
                  <th>Identifier</th>
                  <th>Application</th>
                  <th>Operating System</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <loading-rows v-if="loading" cols='4'/>
                <tr v-for="device in devices" v-if="!loading">
                  <td><router-link :to="{ name: 'Device', params: {id: device.id} }">{{device.identifier}}</router-link></td>
                  <td><router-link :to="{ name: 'App', params: {id: device.app.id} }">{{device.app.uid}}</router-link></td>
                  <td>{{device.os.name}}</td>
                  <td>{{device.created_at | moment('LLL')}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <pagination v-bind:totalEntries="pagination.total_entries" v-bind:totalPages="pagination.total_pages" v-bind:currentPage="pagination.current_page"></pagination>
      </div>
    </div>
  </div>

</template>

<script>

import devices from 'services/devices'
import Pagination from 'components/Pagination'
import LoadingRows from 'components/LoadingRows'

export default {
  name: 'devices',
  created () {
    this.fetchData()
  },
  data () {
    return {
      devices: [],
      loading: false,
      pagination: {},
      order: 'created_at desc'
    }
  },
  computed: {
    page () {
      if (this.$route.query.page) {
        return this.$route.query.page
      }
      return 1
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    Pagination,
    LoadingRows
  },
  methods: {
    fetchData () {
      devices.all(this)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/devices/Devices.vue